/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guides_Path_TitleInputs */

const en_guides_path_title = /** @type {(inputs: Guides_Path_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where to start`)
};

const ko_guides_path_title = /** @type {(inputs: Guides_Path_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어디서 시작할까`)
};

const ja_guides_path_title = /** @type {(inputs: Guides_Path_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どこから読むか`)
};

/**
* | output |
* | --- |
* | "Where to start" |
*
* @param {Guides_Path_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guides_path_title = /** @type {((inputs?: Guides_Path_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guides_Path_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guides_path_title(inputs)
	if (locale === "ko") return ko_guides_path_title(inputs)
	return ja_guides_path_title(inputs)
});